import {ajax} from "@js/modules/ajax.js";
import {showModal} from "@js/modules/modal.js";

let selectedFiles = new Map();
let modal, fileInput, dropZone, filesList, saveBtn, cancelBtn;

function initFilesModal() {
    modal = document.getElementById('filesModal');
    fileInput = document.getElementById('fileInput');
    dropZone = document.getElementById('dropZone');
    filesList = document.getElementById('filesList');
    saveBtn = document.getElementById('save-files');
    cancelBtn = document.getElementById('cancel-files');

    if (!modal) return;

    initEventListeners();
    initPreviewModal();
}

function initEventListeners() {
    dropZone.addEventListener('click', function() {
        fileInput.click();
    });

    fileInput.addEventListener('change', function(e) {
        handleFiles(e.target.files);
    });

    dropZone.addEventListener('dragover', function(e) {
        e.preventDefault();
        dropZone.classList.add('dragover');
    });

    dropZone.addEventListener('dragleave', function() {
        dropZone.classList.remove('dragover');
    });

    dropZone.addEventListener('drop', function(e) {
        e.preventDefault();
        dropZone.classList.remove('dragover');
        handleFiles(e.dataTransfer.files);
    });

    saveBtn.addEventListener('click', saveFiles);
    cancelBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeModal();
        }
    });
}

function initPreviewModal() {
    let previewModal = document.getElementById('imagePreviewModal');
    if (!previewModal) {
        previewModal = document.createElement('dialog');
        previewModal.id = 'imagePreviewModal';
        previewModal.innerHTML = `
            <div class="preview-modal-content">
                <img id="previewImage" src="" alt="Image Preview">
                <button type="button" id="closePreviewModal" class="btn btn--default">Закрыть</button>
            </div>
        `;
        document.body.appendChild(previewModal);
        previewModal.querySelector('#closePreviewModal').addEventListener('click', () => {
            previewModal.close();
        });
        previewModal.addEventListener('click', (e) => {
            if (e.target === previewModal) {
                previewModal.close();
            }
        });
    }
}

function handleFiles(fileList) {
    Array.from(fileList).forEach(function(file) {
        if (isValidFileType(file)) {
            const fileId = generateFileId();
            selectedFiles.set(fileId, {
                file: file,
                comment: ''
            });
            renderFileItem(fileId, file);
        } else {
            alert('Файл "' + file.name + '" имеет неподдерживаемый формат.');
        }
    });

    fileInput.value = '';
}

function isValidFileType(file) {
    const validTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    return validTypes.includes(file.type);
}

function generateFileId() {
    return Date.now() + Math.random().toString(36).substr(2, 9);
}

function renderFileItem(fileId, file) {
    const fileItem = document.createElement('div');
    fileItem.className = 'file-item';
    fileItem.dataset.fileId = fileId;

    const previewClass = getFilePreviewClass(file);
    const fileSize = formatFileSize(file.size);

    fileItem.innerHTML = `
    <div class="file-item__preview ${previewClass}">
        ${previewClass === 'image' ? '<img src="#" alt="' + file.name + '">' : ''}
    </div>
    <div class="file-item__info">
        <div class="file-item__name">${escapeHtml(file.name)}</div>
        <div class="file-item__size">${fileSize}</div>
        <textarea
            class="file-item__comment"
            placeholder="Добавьте комментарий к файлу..."
            data-file-id="${fileId}"
        ></textarea>
    </div>
    <button type="button" class="file-item__remove" data-file-id="${fileId}">×</button>
`;

    if (file.type.startsWith('image/')) {
        loadImagePreview(file, fileItem.querySelector('img'));
    }

    const commentTextarea = fileItem.querySelector('.file-item__comment');
    const removeBtn = fileItem.querySelector('.file-item__remove');

    commentTextarea.addEventListener('input', function(e) {
        updateFileComment(fileId, e.target.value);
    });

    removeBtn.addEventListener('click', function() {
        removeFile(fileId);
    });

    filesList.appendChild(fileItem);
}

function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function getFilePreviewClass(file) {
    if (file.type.startsWith('image/')) return 'image';
    if (file.type === 'application/pdf') return 'pdf';
    if (file.type.includes('word')) return 'doc';
    return 'file';
}

function loadImagePreview(file, imgElement) {
    const reader = new FileReader();
    reader.onload = function(e) {
        imgElement.src = e.target.result;
    };
    reader.readAsDataURL(file);
}

function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function updateFileComment(fileId, comment) {
    if (selectedFiles.has(fileId)) {
        selectedFiles.get(fileId).comment = comment;
    }
}

function removeFile(fileId) {
    selectedFiles.delete(fileId);
    const fileElement = filesList.querySelector('[data-file-id="' + fileId + '"]');
    if (fileElement) {
        fileElement.remove();
    }
}

function saveFiles() {
    const newFilesData = Array.from(selectedFiles.entries()).map(function(entry) {

        const fileId = entry[0];
        const fileData = entry[1];
        return {
            id: fileId,
            name: fileData.file.name,
            type: fileData.file.type,
            size: fileData.file.size,
            comment: fileData.comment,
            file: fileData.file
        };
    });

    const currentFilesData = $('#block_files').data('files-data') || [];
    const updatedFilesData = [...currentFilesData, ...newFilesData];
    $('#block_files').data('files-data', updatedFilesData);

    addFilesToLayout(newFilesData);

    closeModal();
}

function addFilesToLayout(filesData) {
    const fileList = document.querySelector('.js-file-list');
    if (!fileList) return;

    filesData.forEach(function(fileData) {
        const fileElement = document.createElement('li');
        fileElement.className = 'act-info__violation';
        fileElement.dataset.fileId = fileData.id;

        const isImage = fileData.type?.startsWith('image/') || fileData.mime_type?.startsWith('image/') || fileData.filename?.match(/\.(jpeg|jpg|png|gif)$/i);
        const previewClass = isImage ? 'image' : (fileData.filename?.match(/\.pdf$/i) ? 'pdf' : 'doc');

        fileElement.innerHTML = `
            <div class="act-info__violation-header">
                <span class="act-info__violation-title file-preview-link" data-file-id="${fileData.id}">${escapeHtml(fileData.name || fileData.filename)}</span>
                <div class="act-info__violation-actions">
                    <button type="button" class="btn btn--default btn--icon-remove js-del">
                        <span class="btn-label btn-icon">Удалить</span>
                    </button>
                </div>
            </div>
            <div class="act-info__violation-preview ${previewClass}">
                ${isImage ? `<img class="js-file-preview" src="${fileData.file ? '' : '/act/file/' + fileData.id}" alt="${escapeHtml(fileData.name || fileData.filename)}">` : ''}
                <div><span class="file-comment">${escapeHtml(fileData.comment || '')}</span></div>
            </div>
        `;

        const deleteBtn = fileElement.querySelector('.js-del');
        const previewLink = fileElement.querySelector('.file-preview-link');
        const previewImage = fileElement.querySelector('.js-file-preview');

        deleteBtn.addEventListener('click', function(e) {
            const el = e.target;
            const fileId = el.closest('[data-file-id]').dataset.fileId;
            removeFileFromLayout(fileId);
            removeFileFromData(fileId);
        });

        previewLink.addEventListener('click', function () {
            handleFileClick(fileData)
        })

        if(previewImage) {
            previewImage.addEventListener('click', function () {
                handleFileClick(fileData)
            })
        }

        if (isImage && fileData.file) {
            loadImagePreview(fileData.file, fileElement.querySelector('img'));
        }

        fileList.appendChild(fileElement);
    });
}

function handleFileClick(fileData) {

    const isImage = fileData.type?.startsWith('image/') || fileData.mime_type?.startsWith('image/') || fileData.filename?.match(/\.(jpeg|jpg|png|gif)$/i);

    if (isImage) {
        showImagePreview(fileData);
    } else {
        downloadFile(fileData);
    }
}

function showImagePreview(fileData) {
    const previewModal = document.getElementById('imagePreviewModal');
    const previewImage = previewModal.querySelector('#previewImage');

    if (fileData.file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            previewImage.src = e.target.result;
            previewModal.showModal();
        };
        reader.readAsDataURL(fileData.file);
    } else {
        previewImage.src = `/act/file/${fileData.id}`;
        previewModal.showModal();
    }
}

function downloadFile(fileData) {
    if (fileData.file) {
        const url = URL.createObjectURL(fileData.file);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileData.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } else {
        const link = document.createElement('a');
        link.href = `/act/file/${fileData.id}?download=1`;
        link.download = fileData.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

function removeFileFromLayout(fileId) {
    const fileElement = document.querySelector('.act-info__violation[data-file-id="' + fileId + '"]');
    if (fileElement) {
        fileElement.remove();
    }
}

function removeFileFromData(fileId) {
    const currentFilesData = $('#block_files').data('files-data') || [];
    const updatedFilesData = currentFilesData.filter(file => file.id != fileId);
    $('#block_files').data('files-data', updatedFilesData);
}

function openModal() {
    modal.showModal();
}

function closeModal() {
    modal.close();
}

function clearModal() {
    selectedFiles.clear();
    filesList.innerHTML = '';
}

function openFilesModal() {
    clearModal();
    openModal();
}

function openFilesModalWithFiles(files) {
    clearModal();
    handleFiles(files);
    openModal();
}

function getSelectedFiles() {
    return Array.from(selectedFiles.entries()).map(function(entry) {
        const fileId = entry[0];
        const fileData = entry[1];
        return {
            id: fileId,
            name: fileData.file.name,
            type: fileData.file.type,
            size: fileData.file.size,
            comment: fileData.comment
        };
    });
}

function showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = 'notification notification--' + (type || 'info');
    notification.textContent = message;

    document.body.appendChild(notification);

    setTimeout(function() {
        notification.remove();
    }, 3000);
}

document.addEventListener('DOMContentLoaded', function() {
    initFilesModal();

    const uploadFilesModal = document.getElementById('open-files-upload-modal');

    if (!uploadFilesModal) return;

    uploadFilesModal.addEventListener('click', function() {
        openFilesModal();
    });

    // Initialize existing files
    const blockFiles = document.getElementById('block_files');
    const existsFilesJson = blockFiles.dataset.existsFiles;
    let existsFiles = [];
    if (existsFilesJson) {
        try {
            existsFiles = JSON.parse(existsFilesJson);
        } catch (e) {
            console.error('Error parsing existing files:', e);
        }
    }
    const formattedExists = existsFiles.map(file => ({
        id: file.id,
        name: file.filename,
        size: file.size,
        comment: file.comment,
        file: null,
        type: file.mime_type,
    }));
    $('#block_files').data('files-data', formattedExists);
    addFilesToLayout(formattedExists);

    $(blockFiles).find('button.btn--icon-remove').attr('disabled', true);
});
